export default __webpack_public_path__ + "static/media/gift-filled-icon.63ff0865.svg";